import React from 'react';
import { X } from 'lucide-react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cn } from '../../../lib/utils';
import { Dialog, DialogOverlay, DialogPortal, DialogTitle } from '../../../components/ui/dialog';

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  loadingLabel = 'Please wait...',
  destructive = false,
  isLoading = false,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={(next) => !isLoading && onOpenChange(next)}>
    <DialogPortal>
      <DialogOverlay className="bg-[#0a1230]/50 backdrop-blur-sm" />
      <DialogPrimitive.Content
        className={cn(
          'fixed left-[50%] top-[50%] z-50 translate-x-[-50%] translate-y-[-50%]',
          'w-[95vw] sm:w-[90vw] md:w-[420px] max-w-[420px]',
          'bg-white rounded-2xl shadow-[0_30px_80px_-20px_rgba(30,51,131,0.45)] border border-white/60',
          'duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
          'font-sans'
        )}
      >
        <div className="flex items-start justify-between px-6 pt-6 pb-1">
          <DialogTitle className="text-[20px] font-bold text-foreground tracking-tight">{title}</DialogTitle>
          <DialogPrimitive.Close
            disabled={isLoading}
            className="h-9 w-9 grid place-items-center rounded-xl text-[var(--color-text-secondary)] hover:bg-[var(--color-workspace)]/60 hover:text-[var(--color-primary)] transition disabled:opacity-50 shrink-0"
          >
            <X className="h-5 w-5" />
            <span className="sr-only">Close</span>
          </DialogPrimitive.Close>
        </div>

        <p className="px-6 py-3 text-sm text-[var(--color-text-secondary)] leading-relaxed">{message}</p>

        <div className="flex justify-end gap-3 px-6 py-4 border-t border-[var(--color-text-border)]/70">
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
            className="h-11 px-6 rounded-xl border border-[var(--color-text-border)] text-sm font-bold text-foreground hover:bg-[var(--color-workspace)]/50 transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className={cn(
              'h-11 px-6 rounded-xl text-white text-sm font-bold transition disabled:opacity-50 disabled:cursor-not-allowed',
              destructive
                ? 'bg-[var(--color-error)] hover:opacity-90'
                : 'bg-[var(--color-primary)] hover:bg-[var(--color-accent)] shadow-[0_8px_20px_-8px_rgba(30,51,131,0.5)]'
            )}
          >
            {isLoading ? loadingLabel : confirmLabel}
          </button>
        </div>
      </DialogPrimitive.Content>
    </DialogPortal>
  </Dialog>
);